// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"5fe99d69","787":"994511a4"}[chunkId] + ".chunk.js";
};